import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { KreditstopDialogComponentData, KreditstopDialogResponse } from 'src/app/components/aftale/models';
import { ServiceordreStatusEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/serviceordre-status-enum';
import { KreditvurderingDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/kreditvurdering-dto';
import { KreditvaerdigEnumDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/kreditvaerdig-enum-dto';

@Component({
    selector: 'app-kreditstop-dialog',
    templateUrl: './kreditstop-dialog.component.html',
    styleUrls: ['./kreditstop-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class KreditstopDialogComponent {
  form: UntypedFormGroup;
  kreditvurdering: KreditvurderingDto;
  kreditvaerdigEnum = KreditvaerdigEnumDto;
  deadlineAfterPartnerEnd: boolean = false;

  get accept() {
    return this.form.get('accept');
  }
  get acceptTekst() {
    return this.form.get('acceptTekst');
  }

  constructor(
    private formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<KreditstopDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: KreditstopDialogComponentData
  ) {
    this.kreditvurdering = data.kreditvurdering;
    if (data.partnervalidTo) {
      this.deadlineAfterPartnerEnd = new Date(this.data.serviceordre.deadline) > new Date(data.partnervalidTo);
    }
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      accept: [false],
      acceptTekst: [null, [Validators.maxLength(32)]],
    });

    if (
      this.kreditvurdering?.kreditvaerdig == KreditvaerdigEnumDto.No ||
      this.kreditvurdering?.kreditvaerdig == KreditvaerdigEnumDto.Maybe ||
      this.kreditvurdering?.kreditvaerdig == KreditvaerdigEnumDto.NotSet
    ) {
      this.accept.setValidators([Validators.requiredTrue]);
      this.acceptTekst.setValidators([Validators.required, Validators.maxLength(32)]);
    }
  }

  cancel() {
    const result: KreditstopDialogResponse = {
      serviceordreStatus: ServiceordreStatusEnum.Cancelled,
    };
    this.dialogRef.close(result);
  }
  approve() {
    const result: KreditstopDialogResponse = {
      acceptTekst: this.acceptTekst.value,
      serviceordreStatus: ServiceordreStatusEnum.ReadyForBroadcast,
    };
    this.dialogRef.close(result);
  }
}
